import { defineStore } from 'pinia'
import GeneralSettingApi from '@/api/settings/general.api'
import { i18n } from '@/helpers/locale/locale.helper.js'

export const useGeneralSettingStore = defineStore('generalSetting', {
  state: () => ({
    general: {},
    uiFlags: {
      isLoading: false
    },
  }),
  getters: {
    getData(state) {
      return state.general
    },
    getUiFlags(state) {
      return state.uiFlags
    },
    getSingleItem(state) {
      return state.general.destinations
    },
    getAllDestinations(state) {
      return Object.keys(state.general?.destinations || {})?.map((destination, index) => {
        return ({
          name: destination,
          label: i18n.global.t(`settings.destinations_list.${destination.toLowerCase()}`),
          id: index
        })
      })
    }
  },
  actions: {
    async getDestinations(filter = {}) {
      let options = {}
      if (Object.keys(filter).length) {
        options = {
          params: {
            ...filter
          }
        }
      }
      this.uiFlags.isLoading = true
      try {
        const response = await GeneralSettingApi.get(options, 'destinations')
        this.general['destinations'] = response.data.data
      } catch (e) {
        throw new Error(e)
      } finally {
        this.uiFlags.isLoading = false
      }
    },
    async getSingleDestination(data = {}) {
      this.uiFlags.isLoading = true
      try {
        const response = await GeneralSettingApi.create(data, 'destination')
        this.destinations = response.data.data
      } catch (e) {
        throw new Error(e)
      } finally {
        this.uiFlags.isLoading = false
      }
    }
  }
})
